import { createRouteRef } from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const overviewRouteRef = createRouteRef();
export const questionsRouteRef = createRouteRef();
export const heatmapRouteRef = createRouteRef();
export const focusAreasRouteRef = createRouteRef();
export const responseRatesRouteRef = createRouteRef();
